export enum OnboardingStepType {
  WorkspaceCustomization = 'workspace-customization',
  CompanyInfo = 'company-info',
  CoreAreas = 'core-areas',
  Solutions = 'solutions',
  Invite = 'invite',
  RoleAndDiscover = 'role-and-discover',
  GenerateWorkspace = 'generate-workspace',
  ProfileCustomization = 'profile-customization',
}
